import type { Bilingual } from ".";

// Cross-cutting words reused on many screens (buttons, states). Keep this small
// and generic — screen-specific copy belongs in its own area file.
export const common: Bilingual = {
  ms: {
    "common.save": "Simpan",
    "common.secret.show": "Tunjuk",
    "common.secret.hide": "Sorok",
    "common.secret.copy": "Salin",
    "common.secret.copied": "Disalin",
    "common.saving": "Menyimpan…",
    "common.saved": "Disimpan",
    "common.cancel": "Batal",
    "common.delete": "Padam",
    "common.edit": "Ubah",
    "common.add": "Tambah",
    "common.loading": "Memuatkan…",
    "common.search": "Cari",
    "common.close": "Tutup",
    "common.back": "Kembali",
    "common.next": "Seterusnya",
    "common.confirm": "Sahkan",
    "common.view": "Lihat",
    "common.name": "Nama",
    "common.status": "Status",
    "common.updated": "Dikemas kini",
    "common.created": "Dicipta",
    "common.actions": "Tindakan",
    "common.remove": "Buang",
    "common.retry": "Cuba lagi",
    "common.all": "Semua",
    "common.none": "Tiada",
    "common.yes": "Ya",
    "common.no": "Tidak",
    "common.language.ms": "Bahasa Melayu",
    "common.language.en": "English",
    "common.email": "Emel",
    "common.currency": "Mata wang",
    "common.export": "Eksport",
    "common.select.placeholder": "Pilih…",
    "common.select.search": "Cari…",
    "common.select.empty": "Tiada padanan untuk “{q}”.",
    "common.export.rows": "Eksport {count} baris",
    "common.export.csv": "CSV (Excel / Google Sheet)",
    "common.export.xlsx": "Excel (.xlsx)",
    "common.export.empty": "Tiada baris untuk dieksport",
    "common.export.fail": "Eksport gagal",
    "common.export.all": "Semua {count} baris (bukan halaman ini sahaja)",
    "common.page.showing": "{from}–{to} daripada {total}",
    "common.page.prev": "Sebelum",
    "common.page.next": "Seterusnya",
    "common.page.of": "Halaman {page} / {pages}",
    "common.page.perPage": "Baris setiap halaman",
    "common.page.all": "Semua",
  },
  en: {
    "common.save": "Save",
    "common.secret.show": "Show",
    "common.secret.hide": "Hide",
    "common.secret.copy": "Copy",
    "common.secret.copied": "Copied",
    "common.saving": "Saving…",
    "common.saved": "Saved",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.loading": "Loading…",
    "common.search": "Search",
    "common.close": "Close",
    "common.back": "Back",
    "common.next": "Next",
    "common.confirm": "Confirm",
    "common.view": "View",
    "common.name": "Name",
    "common.status": "Status",
    "common.updated": "Updated",
    "common.created": "Created",
    "common.actions": "Actions",
    "common.remove": "Remove",
    "common.retry": "Retry",
    "common.all": "All",
    "common.none": "None",
    "common.yes": "Yes",
    "common.no": "No",
    "common.language.ms": "Bahasa Melayu",
    "common.language.en": "English",
    "common.email": "Email",
    "common.currency": "Currency",
    "common.export": "Export",
    "common.select.placeholder": "Select…",
    "common.select.search": "Search…",
    "common.select.empty": "No match for “{q}”.",
    "common.export.rows": "Export {count} rows",
    "common.export.csv": "CSV (Excel / Google Sheet)",
    "common.export.xlsx": "Excel (.xlsx)",
    "common.export.empty": "Nothing to export",
    "common.export.fail": "Export failed",
    "common.export.all": "All {count} rows (not just this page)",
    "common.page.showing": "{from}–{to} of {total}",
    "common.page.prev": "Previous",
    "common.page.next": "Next",
    "common.page.of": "Page {page} / {pages}",
    "common.page.perPage": "Rows per page",
    "common.page.all": "All",
  },
};
